export const Flag = ({ code, className = "w-[22px] h-[15px]" }) => {
  const base = { width: "100%", height: "100%", display: "block" };
  const flags = {
    ES: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="30" height="20" fill="#AA151B" />
        <rect y="5" width="30" height="10" fill="#F1BF00" />
      </svg>
    ),
    DE: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="30" height="20" fill="#111" />
        <rect y="6.66" width="30" height="6.67" fill="#DD0000" />
        <rect y="13.33" width="30" height="6.67" fill="#FFCE00" />
      </svg>
    ),
    FR: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="10" height="20" fill="#0055A4" />
        <rect x="10" width="10" height="20" fill="#F3F3F0" />
        <rect x="20" width="10" height="20" fill="#EF4135" />
      </svg>
    ),
    BE: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="10" height="20" fill="#111" />
        <rect x="10" width="10" height="20" fill="#FDDA24" />
        <rect x="20" width="10" height="20" fill="#EF3340" />
      </svg>
    ),
    NL: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="30" height="20" fill="#AE1C28" />
        <rect y="6.66" width="30" height="6.67" fill="#F3F3F0" />
        <rect y="13.33" width="30" height="6.67" fill="#21468B" />
      </svg>
    ),
    IT: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="10" height="20" fill="#008C45" />
        <rect x="10" width="10" height="20" fill="#F4F5F0" />
        <rect x="20" width="10" height="20" fill="#CD212A" />
      </svg>
    ),
    PT: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="30" height="20" fill="#FF0000" />
        <rect width="12" height="20" fill="#046A38" />
        <circle cx="12" cy="10" r="3.6" fill="#FEDD00" stroke="#111" strokeWidth="0.5" />
      </svg>
    ),
    AE: (
      <svg viewBox="0 0 30 20" style={base} preserveAspectRatio="none">
        <rect width="30" height="20" fill="#00732F" />
        <rect y="6.66" width="30" height="6.67" fill="#F3F3F0" />
        <rect y="13.33" width="30" height="6.67" fill="#111" />
        <rect width="8" height="20" fill="#FF0000" />
      </svg>
    ),
  };
  return (
    <span className={`inline-block overflow-hidden rounded-[1px] ${className}`} data-testid={`flag-${code.toLowerCase()}`}>
      {flags[code] || null}
    </span>
  );
};

export default Flag;
